import { useApolloClient } from '@apollo/client/react';
import {
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Tooltip,
} from '@mui/material';
import { NavLink } from 'react-router-dom';

import { type SidebarSingleLinkConfig } from '@app/components/sidebar/sidebarLinkConfig';
import {
  SIDEBAR_ICON_SIZE,
  navItemSx,
} from '@app/components/sidebar/sidebarNavStyles';

type Props = {
  link: SidebarSingleLinkConfig;
  collapsed: boolean;
};

export const SidebarNavItem = ({ link, collapsed }: Props) => {
  const client = useApolloClient();
  const { prefetch, icon: Icon } = link;

  return (
    <NavLink
      to={link.path}
      style={{ textDecoration: 'none', color: 'inherit' }}
      onMouseEnter={prefetch ? () => client.query(prefetch) : undefined}
    >
      {({ isActive }) => (
        <Tooltip
          title={collapsed ? link.label : ''}
          placement="right"
          arrow
          disableInteractive
        >
          <ListItemButton
            selected={isActive}
            disableRipple={true}
            sx={navItemSx(collapsed)}
          >
            <ListItemIcon
              sx={{
                minWidth: 0,
                mr: 1.5,
                justifyContent: 'center',
                color: 'inherit',
              }}
            >
              <Icon size={SIDEBAR_ICON_SIZE} />
            </ListItemIcon>
            {!collapsed && (
              <ListItemText
                primary={link.label}
                slotProps={{
                  primary: {
                    sx: { fontSize: 14, fontWeight: 500 },
                    noWrap: true,
                  },
                }}
              />
            )}
          </ListItemButton>
        </Tooltip>
      )}
    </NavLink>
  );
};
